/**
 * Una fila de configuración de la IA: global, corporación, tipo de examen o curso.
 *
 * `settings` es el JSON con SOLO lo que este ámbito sobrescribe, no el resultado. El resultado se
 * calcula subiendo por `parentId` y se pide aparte, con /ai/resolveConfig.
 */
export class AiConfigDto {
  id: number;
  corpId: number;
  scopeType: 'GLOBAL' | 'CORP' | 'PROFILE' | 'COURSE';
  scopeId: number;
  parentId: number;
  name: string;
  code: string;
  settings: string;
  notes: string;
  active: boolean;
  created: string;
  modified: string;
}

/** Una entrada del catálogo de knobs, venga del enum del código o de ai_setting_def. */
export class AiSettingDefDto {
  id: number;
  key: string;
  type: string;
  defaultValue: string;
  description: string;
  /** Lo lee el orquestador. Los que no, sólo se pintan en el texto del prompt. */
  usedByCode: boolean;
  prompts: string[];
  /** Dado de alta desde esta pantalla, y por tanto editable y borrable. */
  custom: boolean;
}

/** La configuración ya resuelta para un curso, con la procedencia de cada clave. */
export class AiSettingsDto {
  values: { [key: string]: string };
  origin: { [key: string]: string };
  unknownKeys: string[];
  invalidKeys: string[];
  chain: string[];
  profileId: number;
}

/** El prompt final tal y como lo recibe el modelo, con la procedencia de cada pieza. */
export class AiPromptPreviewDto {
  content: string;
  blocks: string[];
  chain: string[];
  settings: AiPromptPreviewSettingDto[];
  unresolved: string[];
  unknownKeys: string[];
  invalidKeys: string[];
  monolithic: boolean;
}

export class AiPromptPreviewSettingDto {
  key: string;
  value: string;
  origin: string;
  usedByCode: boolean;
}

/** Configuración deducida de las preguntas que el curso ya tiene. Se propone, no se guarda. */
export class AiConfigSuggestionDto {
  settings: { [key: string]: string };
  reasons: { [key: string]: string };
  sampleSize: number;
  warnings: string[];
}
